import React, { useState, useEffect } from "react"
import { Card, CardBody, Spinner, Button } from "reactstrap"
import axios from "axios"
import { connect } from "react-redux"
import Select from "react-select"
import Web3 from "web3"
import { useContracts, useWallet } from "../libs/useMetaMaskWallet"
import TradingCard from "../Components/TradingCard"
import {
    setLoading,
    setMoreItemsLoading,
    setTradingItems,
    addTradingItems,
    setTradingTokens,
    setLastEvaluatedKey
} from "../store/trading/tradingActions"
import AvalancheNFTTradingAbis from "../abi/AvalancheNFTTradingAbis"
import PolygonNFTTradingAbis from "../abi/PolygonNFTTradingAbis"
import MetamaskLogo from "../assets/images/metamask.png"
import { convertTradingTokenToNFTDetails } from "../utils"
import { setNetworkOption, setToastMessage, setAllTokens, setNetwork } from "../store/common/commonActions"
import { ChainUnsupportedError } from "../libs/useMetaMaskWallet/error"
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Slider } from "@material-ui/core"

const SortItems = [
    {
        label: "Created",
        value: "inserted"
    },
    {
        label: "Listed",
        value: "updated"
    },
    {
        label: "Price",
        value: "price"
    }
    // {
    //   label: 'Purchased',
    //   value: 'Purchased'
    // }
]

const SortDirection = [
    {
        label: "Oldest first",
        value: "Oldest first"
    },
    {
        label: "Newest first",
        value: "Newest first"
    }
]

const AVALANCHE_NFT_TRADING_CONTRACT_ADDRESS = "0xBA3f705477Ae92B4aF8077249a24cbe5cF9359E3"
const provider = "https://api.avax.network/ext/bc/C/rpc"
const web3Provider = new Web3.providers.HttpProvider(provider)
const web3 = new Web3(web3Provider)

const Trading = (props) => {
    const {
        loading,
        moreItemsLoading,
        items,
        tokens,
        lastEvaluatedKey,
        setLoading,
        setMoreItemsLoading,
        setTradingItems,
        addTradingItems,
        setTradingTokens,
        setLastEvaluatedKey,
        setNetworkOption,
        setToastMessage,
        setAllTokens
    } = props

    const wallet = useWallet()
    const contracts = useContracts()
    const tradingApi = "https://nft.idexo.io"

    const [selectedSortItem, setSelectedSortItem] = useState(SortItems[0])
    const [selectedSortDirection, setSelectedSortDirection] = useState(SortDirection[0])
    const [priceRange, setPriceRange] = useState([0, 99])
    const [number, setNumber] = useState(0)
    const [getNumber, setGetNumber] = useState("0x00")
    const SimpleContract = new web3.eth.Contract(AvalancheNFTTradingAbis, AVALANCHE_NFT_TRADING_CONTRACT_ADDRESS)
    const [filteredTokens, setFilteredTokens] = useState([])
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [openInstallMetaMaskDialog, setOpenInstallMetaMaskDialog] = useState(false)

    useEffect(() => {
        const fetchNFT = async () => {
            const trading_tokens = []
            for (let i = 0; i < items.length; i++) {
                const item = convertTradingTokenToNFTDetails(items[i])
                if (item.source.includes("avalanche") && wallet?.ethereum?.network?.chainId === 43114) {
                    const token_uri = await contracts.avalanche.getTokenURI(item.token_id)
                    const token_details = await axios.get(token_uri)
                    trading_tokens.push({
                        ...item,
                        details: token_details.data
                    })
                } else if (item.source.includes("polygon") && wallet?.ethereum?.network?.chainId === 137) {
                    const token_uri = await contracts.polygon.getTokenURI(item.token_id)
                    const token_details = await axios.get(token_uri)
                    trading_tokens.push({
                        ...item,
                        details: token_details.data
                    })
                }
            }
            setTradingTokens(trading_tokens)
            setAllTokens(trading_tokens)
        }

        if (wallet.status === "connected") {
            setIsConnectedToWallet(true)
        } else {
            setIsConnectedToWallet(false)
        }
        if (items.length) {
            fetchNFT()
        }
    }, [contracts, wallet, items, items.length, setLoading, setTradingTokens, setAllTokens])

    useEffect(() => {
        if (items.length) return

        if (wallet.status === "connected") {
            fetchItems(0, 99)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wallet])

    useEffect(() => {
        if (selectedSortDirection.value === "Newest first") {
            tokens.sort(function (a, b) {
                return b[selectedSortItem.value] - a[selectedSortItem.value]
            })
        } else {
            tokens.sort(function (a, b) {
                return a[selectedSortItem.value] - b[selectedSortItem.value]
            })
        }
        setFilteredTokens(tokens)
    }, [selectedSortDirection, selectedSortItem, tokens, tokens.length])

    const handleGet = async () => {
        const result = await SimpleContract.methods.getBalance().call()
        setGetNumber(result)
        console.log("getBalance", result)
        web3.eth.getBlockNumber().then((result) => {
            console.log("Latest Ethereum Block is ", result)
        })
    }

    handleGet()
    // console.log(SimpleContract)

    const handleConnect = async () => {
        setNetworkOption("")
        setNetwork("Metamask")
        try {
            await wallet.connect()
            if (wallet.error && wallet.error.name === "NoEthereumProviderError") {
                setOpenInstallMetaMaskDialog(true)
            } else {
                setIsConnectedToWallet(true)
            }
        } catch (error) {
            setNetworkOption("Ethereum")
            if (error instanceof ChainUnsupportedError) {
                console.log(error.message)
                setToastMessage("error", error.message)
            } else {
                console.error(error)
                setOpenInstallMetaMaskDialog(true)
            }
        }
    }

    const goToInstallMetaMaskPage = () => {
        window.open("https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn", "_blank")
        setOpenInstallMetaMaskDialog(false)
    }

    const handleChange = (event, newValue) => {
        setPriceRange(newValue)
    }

    const fetchItems = (min, max) => {
        setTradingTokens([])
        setAllTokens([])
        setTradingItems([])
        setLoading(true)
        fetch(`${tradingApi}/?min=${min}&max=${max}&forward=true&limit=4&startkey=null`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            json: true
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    alert("Error: " + data.error)
                } else {
                    if (data.data && data.data.Items) {
                        setTradingItems(data.data.Items)
                        setLastEvaluatedKey(JSON.stringify(data.data.LastEvaluatedKey))
                    }
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const fetchMoreItems = (min, max) => {
        setMoreItemsLoading(true)
        fetch(`${tradingApi}/?min=${min}&max=${max}&forward=true&limit=4&startkey=${lastEvaluatedKey}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                token: localStorage.jwtToken
            },
            json: true
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.error) {
                    alert("Error: " + data.error)
                } else {
                    if (data.data && data.data.Items) {
                        addTradingItems(data.data.Items)
                        setLastEvaluatedKey(encodeURIComponent(JSON.stringify(data.data.LastEvaluatedKey)))
                    }
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    return (
        <React.Fragment>
            <div className="content trading-page">
                <Card>
                    <CardBody>
                        {!isConnectedToWallet ? (
                            <div className="d-flex flex-column text-center justify-content-center align-items-center py-5">
                                <div className="metamask_logo">
                                    <img src={MetamaskLogo} alt="metamask" style={{ width: 150 }} />
                                </div>
                                <h1 className="mt-4">Connect Wallet</h1>
                                <p>
                                    Connecting you Ethereum and the Decentralized Web.
                                    <br />
                                    We're happy to see you.
                                </p>
                                <Button color="primary" className="waves-effect waves-light" style={{ width: 200 }} onClick={() => handleConnect()}>
                                    Connect
                                </Button>
                            </div>
                        ) : (
                            <div>
                                <div className="header">
                                    <div className="search">
                                        <div className="search-input">
                                            <input id="searchInput" type="text" className="form-control" onKeyPress={() => {}} />
                                            <span id="searchSpan" className="bx bx-search" />
                                        </div>
                                        {/* <Link to='trading/new' className="btn btn-primary btn-md mr-3">Create New</Link> */}
                                    </div>
                                    <div className="sort-by">
                                        <span>Sort by:</span>
                                        <div className="sort-select">
                                            <Select
                                                value={selectedSortItem}
                                                onChange={(item) => setSelectedSortItem(item)}
                                                options={SortItems}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                        <div className="sort-select">
                                            <Select
                                                value={selectedSortDirection}
                                                onChange={(item) => setSelectedSortDirection(item)}
                                                options={SortDirection}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="price-range">
                                    <span>Price range:</span>
                                    <div className="price-range-select">
                                        <Slider
                                            value={priceRange}
                                            onChange={handleChange}
                                            onChangeCommitted={() => fetchItems(priceRange[0], priceRange[1])}
                                            valueLabelDisplay="on"
                                            aria-labelledby="range-slider"
                                            max={1000}
                                        />
                                    </div>
                                </div>
                                {loading && (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 400 }}>
                                        <Spinner size="lg" color="primary" />
                                    </div>
                                )}
                                {loading || filteredTokens.length ? (
                                    <div className="card-list">
                                        {!loading && filteredTokens.map((item, index) => <TradingCard data={item} key={index} buy={true} />)}
                                    </div>
                                ) : (
                                    <div className="d-flex flex-column text-center justify-content-center align-items-center py-5">
                                        <div className="metamask_logo">
                                            <img src={MetamaskLogo} alt="metamask" style={{ width: 150 }} />
                                        </div>
                                        <h1 className="mt-4">No NFT Token</h1>
                                    </div>
                                )}
                            </div>
                        )}
                        {!loading && lastEvaluatedKey && (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 100 }}>
                                {moreItemsLoading ? (
                                    <Spinner size="lg" color="primary" />
                                ) : (
                                    <Button outline color="primary" size="lg" onClick={() => fetchMoreItems(priceRange[0], priceRange[1])}>
                                        Load More
                                    </Button>
                                )}
                            </div>
                        )}
                    </CardBody>
                </Card>
                <Dialog
                    open={openInstallMetaMaskDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="sm"
                    fullWidth
                    onClose={() => setOpenInstallMetaMaskDialog(false)}
                >
                    <DialogTitle id="alert-dialog-title">Install MetaMask</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">Please install MetaMask wallet on your browser to connect</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" autoFocus onClick={goToInstallMetaMaskPage}>
                            {" "}
                            Install MetaMask{" "}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => ({
    loading: state.tradingReducer.loading,
    moreItemsLoading: state.tradingReducer.moreItemsLoading,
    items: state.tradingReducer.items,
    tokens: state.tradingReducer.tokens,
    lastEvaluatedKey: state.tradingReducer.lastEvaluatedKey
})

const mapDispatchToProps = {
    setLoading,
    setMoreItemsLoading,
    setTradingItems,
    addTradingItems,
    setTradingTokens,
    setLastEvaluatedKey,
    setNetworkOption,
    setToastMessage,
    setAllTokens,
    setNetwork
}

export default connect(mapStateToProps, mapDispatchToProps)(Trading)
